import { reactive, computed } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export const useSubscriptionsForm = () => {
    const state = reactive({
        id: '',
        topic: '',
        user: '',
        status: 1,
    });

    const setState = (c) => {
        state.id = c.id;
        state.topic = c.topic;
        state.user = c.user;
        state.status = c.status;
    };

    const rules = computed(() => ({
        topic: { required },
        user: { required },
    }));

    const $v = useVuelidate(rules, state);

    return {
        state,
        setState,
        $v,
        rules,
    };
};

export default {};
